module.exports = __webpack_public_path__ + "static/media/sc32.34.35.1f9125ce.mp4";